export const ROUTES = {
  dashboard: "/",
  profile: "/profile",
  profileTelegram: "/profile/telegram",
  profileName: "/profile/name",
  profileEmail: "/profile/email",
  profilePhone: "/profile/phone",
  profilePassword: "/profile/password",
  login: "/login",
  forgotPassword: "/forgot-password",
  registration: "/registration",
  registrationSuccess: "/registration-success",
  registrationError: "/registration-error",
  resetPasswordSuccess: "/reset-password-success",
  members: "/members",
  memberDetail: (id: string) => `/member/${id}`,
  projects: "/projects",
  addProject: "/projects/add",
  project: (id: string) => `/projects/${id}`,
  projectSettings: (id: string) => `/projects/${id}/settings`,
  folders: (id: string) => `/projects/${id}/folders`,
  folder: (projectId: string, folderId: string) =>
    `/projects/${projectId}/folders/${folderId}`,
  reports: (id: string) => `/projects/${id}/reports`,
  documents: (id: string) => `/projects/${id}/documents`,
  sources: (id: string) => `/projects/${id}/sources`,
  projectMembers: (id: string) => `/projects/${id}/members`,
};
